import * as types from './types'
import { useAxiosModule } from '@/modules/_shared/axios'
import { FreeSubscriptionSearchFilter } from '@/views/_shared/search-list/types'

const { postToApi, getFromApi, putToApi, deleteInApi } = useAxiosModule()

export type GetFreeSubscriptionsListResponse = types.GetFreeSubscriptionsList

export const getFreeSubscriptions = async (search = {} as FreeSubscriptionSearchFilter, orderBy = 'id desc', limit = 0, offset = 0) => {
    const queryParams = new URLSearchParams()
    queryParams.set('subscriptionType', search.subscriptionType)
    queryParams.set('processType', search.processType)
    queryParams.set('createdBy', search.createdBy)
    queryParams.set('searchByUserPhrase', search.user)
    queryParams.set('searchBySubscriptionIdPhrase', search.id)
    queryParams.set('startDate', search.startDate)
    queryParams.set('endDate', search.endDate)
    queryParams.set('sort', orderBy)
    queryParams.set('limit', String(limit))
    queryParams.set('offset', String(offset))
    const getFilteredFreeSubscriptionsUrl = 'subscriptions/?' + queryParams.toString()
    return getFromApi<GetFreeSubscriptionsListResponse>(getFilteredFreeSubscriptionsUrl)
}

export type GetFreeSubscriptionResponse = types.FreeSubscription
export const getFreeSubscription = async (id: string) =>
    getFromApi<GetFreeSubscriptionResponse>(`subscriptions/${id}`)

export type AddFreeSubscriptionRequest = types.AddFreeSubscription
export const addFreeSubscription = async (req: AddFreeSubscriptionRequest) =>
    postToApi<null>('subscriptions/', req)

export type UpdateFreeSubscriptionEndDate = types.ChangeFreeSubscriptionEndDate
export const updateFreeSubscriptionEndDate = async (subscriptionId: string, req: UpdateFreeSubscriptionEndDate) =>
    await putToApi<null>(`subscriptions/${subscriptionId}/end-date`, req)

export type UpdateFreeSubscriptionPackages = types.ChangeFreeSubscriptionPackages
export const updateFreeSubscriptionPackages = async (subscriptionId: string, req: UpdateFreeSubscriptionPackages) =>
    await putToApi<null>(`subscriptions/${subscriptionId}/packages`, req)

export const deleteFreeSubscription = async (subscriptionId: string) =>
    deleteInApi<null>(`subscriptions/${subscriptionId}`, { subscriptionId: subscriptionId })
